/**
 * @generated SignedSource<<b157fc911476dc234f2bb1bfaf2175db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewRichText_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "AnswerRichText",
  "abstractKey": null
};

node.hash = "d6113c70c36f93bba83cceaf13406f48";

module.exports = node;
